import { SkeletonCircleComponent, SkeletonLinesComponent } from "@iventis/components";
import styled from "@emotion/styled";
import React, { FunctionComponent } from "react";

type ChangeLogItemSkeletonProps = { className?: string };

export const ChangeLogItemSkeltonComponent: FunctionComponent<ChangeLogItemSkeletonProps> = ({ className }) => (
    <div className={className}>
        <StyledHeader>
            <StyledHeaderItem>
                <TitleContainer>
                    <IconSkeleton>
                        <SkeletonCircleComponent width="12px" />
                    </IconSkeleton>
                    <SkeletonLinesComponent width="220px" height="15px" />
                    <SubTitleSkeleton>
                        <SkeletonLinesComponent width="140px" height="13px" />
                    </SubTitleSkeleton>
                </TitleContainer>
            </StyledHeaderItem>
            <StyledHeaderItem>
                <RightTextSkeleton>
                    <SkeletonLinesComponent width="160px" height="14px" />
                </RightTextSkeleton>
                <RightTextSkeleton>
                    <SkeletonLinesComponent width="120px" height="14px" />
                </RightTextSkeleton>
            </StyledHeaderItem>
        </StyledHeader>
    </div>
);

const StyledHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const StyledHeaderItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const TitleContainer = styled.div`
    display: grid;
    grid-template-columns: 10px 1fr;
    column-gap: 8px;
    align-items: center;
`;

const IconSkeleton = styled.div`
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SubTitleSkeleton = styled.div`
    grid-column: 2;
`;

const RightTextSkeleton = styled.div`
    display: flex;
    justify-content: flex-end;
`;
